// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"23e46926","498":"acb086ec","703":"98541e94"}[chunkId] + ".chunk.js";
};